import React from 'react';

interface VenereIconCleanProps {
  size?: number;
  className?: string;
  color?: string;
  onClick?: () => void;
}

export const VenereDrop: React.FC<VenereIconCleanProps> = ({
  size = 24,
  className = '',
  color = 'currentColor',
  onClick,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 2000 2000"
      fill={color}
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path d="M1585.8,1159.39c0-311.81-524.96-865.47-547.26-888.83-20.1-21.04-56.98-21.04-77.09,0-14.11,14.79-347.56,365.94-486.29,663.57-12.38,26.69-.87,58.31,25.76,70.76,26.69,12.38,58.31.87,70.76-25.76,104.65-224.47,336.78-492.14,428.51-593.46,162.77,178.53,479.1,567.9,479.1,773.73,0,264.28-215.02,479.3-479.3,479.3s-479.3-215.02-479.3-479.3c0-29.42-23.83-53.26-53.26-53.26s-53.25,23.83-53.25,53.26c0,322.99,262.82,585.81,585.81,585.81s585.81-262.82,585.81-585.81h-.01Z"/>
      <path d="M1000,781.27c-31.7,0-57.4,25.7-57.4,57.4v165.71h-165.71c-31.7,0-57.4,25.7-57.4,57.4s25.69,57.4,57.4,57.4h165.71v165.71c0,31.7,25.69,57.4,57.4,57.4s57.4-25.7,57.4-57.4v-165.71h165.71c31.7,0,57.4-25.7,57.4-57.4s-25.69-57.4-57.4-57.4h-165.71v-165.71c0-31.7-25.69-57.4-57.4-57.4Z"/>
    </svg>
  );
};

export default VenereDrop; 